import { useEffect, useState } from "react";
import { NavLink, useParams, useHistory } from "react-router-dom";
import CountsCard from "../../../components/dashboard/CountsCard";
import RowMember from "../../../components/rows/row-member";
import {
  getFreeEmployees,
  getTeam,
  getTeamMembers,
  getFreeLeaders,
  deleteTeam,
} from "../../../http";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setTeam, setTeamInformation } from "../../../store/team-slice";
import {
  setFreeEmployees,
  setTeamMembers,
  setFreeLeaders,
} from "../../../store/user-slice";
import LeaderModal from "./modal/LeaderModal";
import LeadersModal from "./modal/LeadersModal";
import MembersModal from "./modal/MembersModal";
import DeleteTeamModal from "./modal/DeleteTeamModal";
import { toast } from "react-toastify";

const Team = () => {
  const dispatch = useDispatch();
  const { team } = useSelector((state) => state.teamSlice);
  const { teamMembers } = useSelector((state) => state.userSlice);
  const { user } = useSelector((state) => state.authSlice);
  const navigate = useHistory();
  const [loading, setLoading] = useState(true);
  const [freeApiCalled, setFreeApiCalled] = useState(false);
  // const [freeLeaderCalled, setFreeLeaderApiCalled] = useState(false);
  const [membersLoading, setMembersLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showLeaderModal, setShowLeaderModal] = useState(false);
  const [showLeadersModal, setShowLeadersModal] = useState(false);

  // let userRole = localStorage.getItem('user');

  // Delete Team Modal Handler
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigator = useHistory();

  const { id } = useParams();
  useEffect(() => {
    (async () => {
      const res = await getTeam(id);

      if (res.data.success) {
        dispatch(setTeam(res.data.data));
        dispatch(setTeamInformation(res.data.data.information));
        setLoading(false);
      }
      const res1 = await getTeamMembers(id);

      if (res1.data.success) {
        dispatch(setTeamMembers(res1.data.data));
        setMembersLoading(false);
      }
    })();
  }, [id]);

  const delteHandler = () => {
    setIsModalVisible(true);
  };

  const handleDelete = async () => {
    try {
      const response = await deleteTeam(id);

      if (response.data.success) {
        // Show success toast
        toast.success("Team deleted successfully!");

        // Redirect to the teams list page
        navigator.push("/teams");
      } else {
        // Show failure toast
        toast.error("Failed to delete the team. Please try again.");
      }
    } catch (error) {
      // Show error toast
      toast.error("An error occurred. Please try again later.");
      console.error("Error during deletion:", error);
    }
  };

  const modalAction = async () => {
    setShowModal(showModal ? false : true);
    if (!freeApiCalled) {
      const res = await getFreeEmployees();

      if (res.data.success) {
        const freeEmployees = res.data.data.filter(
          (employee) => !teamMembers.some((member) => member.id === employee.id)
        );
        dispatch(setFreeEmployees(freeEmployees));
      }
      setFreeApiCalled(true);
    }
  };

  const modalLeadersAction = async () => {
    setShowLeadersModal(showLeadersModal ? false : true);
    // if (!freeLeaderCalled) {
    const res = await getFreeLeaders();

    if (res.data.success) {
      dispatch(setFreeLeaders(res.data.data));
    }
    //   setFreeLeaderApiCalled(true);
    // }
  };

  const modalLeaderAction = () => {
    setShowLeaderModal(showLeaderModal ? false : true);
  };

  return (
    <>
      {showModal && <MembersModal close={modalAction} />}
      {showLeaderModal && <LeaderModal close={modalLeaderAction} />}
      {showLeadersModal && <LeadersModal close={modalLeadersAction} />}

      <div className="main-content">
        <section className="section">
          {team && (
            <>
              <div className="section-header  d-flex justify-content-between">
                <h1>Team</h1>
                <div>
                  <button
                    className="btn btn-primary mr-4"
                    onClick={() => {
                      navigate.push("/teams");
                    }}
                  >
                    Back
                  </button>
                  <NavLink
                    to={`/editteam/${id}`}
                    className="btn btn-primary mr-4"
                  >
                    Edit Team
                  </NavLink>
                  <button
                    className="btn btn-danger mr-4"
                    onClick={delteHandler}
                  >
                    Delete Team
                  </button>

                  {team.status === "Active" && (
                    <button onClick={modalAction} className="btn btn-primary">
                      Add Member
                    </button>
                  )}
                </div>
                <DeleteTeamModal
                  show={isModalVisible}
                  onClose={() => setIsModalVisible(false)}
                  onDelete={handleDelete}
                />
              </div>
              <div className="row">
                <CountsCard
                  title="Total Employee"
                  icon="fa-user"
                  count={team.information.employee}
                />
              </div>

              <div className="card">
                <div className="card-body row">
                  <div className="col-md-3 ">
                    <img
                      className="img-fluid img-thumbnail"
                      src={team.image}
                      alt=""
                    />
                  </div>
                  <div className="col-md-9">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th>Name</th>
                          <td>{team.name}</td>
                        </tr>
                        <tr>
                          <th>Description</th>
                          <td>{team.description}</td>
                        </tr>
                        <tr>
                          <th>Leader</th>
                          <td>
                            {team.leader ? (
                              <button
                                className="badge btn badge-primary"
                                onClick={modalLeaderAction}
                                style={{ padding: "0px 10px 0px 0px" }}
                              >
                                <img
                                  src={team.leader.image}
                                  className="avatar avatar-sm mr-2"
                                  alt="Person"
                                  width="96"
                                  height="96"
                                />
                                {team.leader.name}
                              </button>
                            ) : (
                              <button
                                onClick={modalLeadersAction}
                                className="badge badge-light btn"
                                style={{ padding: "0px 10px 0px 0px" }}
                              >
                                <img
                                  src="../assets/icons/user.png"
                                  className="avatar avatar-sm mr-2"
                                  alt="Person"
                                />
                                No Leader
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}

          {!membersLoading && (
            <div className="card">
              <div className="card-header">
                <h4>All Employees</h4>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-striped table-md center-text">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading &&
                        teamMembers &&
                        teamMembers.map((data, index) => {
                          return (
                            <RowMember
                              key={index}
                              index={index + 1}
                              data={data}
                            />
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </>
  );
};

export default Team;
